/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindUsersResponseDto } from '../../models/find-users-response-dto';

export interface FindUsers$Params {
  type?: string;
  s?: string;
  greylist?: string;
  inumis_id?: string;
  custom_id?: string;
  prebid_alert?: string;
  verification_req?: string;
  verification_state?: string;
  accepted_bid_min_sum?: number;
  accepted_bid_filter_from?: string;
  accepted_bid_filter_until?: string;
  '$sortby': string;
  '$sortdir': string;
  '$page': number;
  '$maxpagesize': number;
  'X-API-Version'?: string;
}

export function findUsers(http: HttpClient, rootUrl: string, params: FindUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<FindUsersResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findUsers.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.query('s', params.s, {});
    rb.query('greylist', params.greylist, {});
    rb.query('inumis_id', params.inumis_id, {});
    rb.query('custom_id', params.custom_id, {});
    rb.query('prebid_alert', params.prebid_alert, {});
    rb.query('verification_req', params.verification_req, {});
    rb.query('verification_state', params.verification_state, {});
    rb.query('accepted_bid_min_sum', params.accepted_bid_min_sum, {});
    rb.query('accepted_bid_filter_from', params.accepted_bid_filter_from, {});
    rb.query('accepted_bid_filter_until', params.accepted_bid_filter_until, {});
    rb.query('$sortby', params['$sortby'], {});
    rb.query('$sortdir', params['$sortdir'], {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindUsersResponseDto>;
    })
  );
}

findUsers.PATH = '/api/users';
